import { isFlagEnabled } from "js/utilities";
import { depricated_getPaymentUID } from "./depricated_getPaymentUID";
import { releaseing_getPaymentUID } from "./releaseing_getPaymentUID";

export default isFlagEnabled(
  "ENABLE_NAME_VALIDATION_ON_AUTHORIZE_PAYMENT_MODAL"
)
  ? releaseing_getPaymentUID
  : depricated_getPaymentUID;
